import React, { useState } from 'react';
import classnames from 'classnames';
import { FolderCardLayout } from '@wix/da-shared-react/pkg/FolderCard';
import { GallectionType } from '@wix/da-shared-react/pkg/types/gallection';
import { getFolderCardSizeBasedOnWidth } from '@wix/da-shared-react/pkg/FolderCard/helpers';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import PlusIcon from '@wix/da-ds/pkg/Icons/Plus';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import MediaManager from '@wix/da-shared-react/pkg/MediaPopup/MediaManager';
import { MediaSourceType } from '@wix/da-shared-react/pkg/MediaPopup/types';
import { useTranslation } from 'react-i18next';
import s from './AddNewFolderCard.scss';

export type Props = {
  width: number;
  className?: string;
  gallectionType: GallectionType;
};
export const AddNewFolderCard: React.FC<Props> = ({
  className,
  width,
  gallectionType,
}) => {
  const { t } = useTranslation();
  const [isMediaManagerShown, setShowMediaManager] = useState(false);
  const closeMediaManagerAndReload = event => {
    setShowMediaManager(false);
    event && event.preventDefault();
    window.location.reload();
  };
  const size = getFolderCardSizeBasedOnWidth(width);
  const headingTransKeys = {
    gallery: 'pages.gallections.gallery.addNew',
    collection: 'pages.gallections.collection.addNew',
  };

  return (
    <>
      <FolderCardLayout
        className={classnames(className, s[size])}
        width={width}
        onClick={() => setShowMediaManager(true)}
        content={
          <div className={s['thumb-aspect-wrapper']}>
            <div className={s['thumb-content']}>
              <PlusIcon size={IconSize.BIG} />
            </div>
          </div>
        }
        footer={
          <div className={s['footer']}>
            <div className={s['description']}>
              <div className={s['name']}>
                <Heading>{t(headingTransKeys[gallectionType])}</Heading>
              </div>
              <div className={s['stats']}>
                {/* FolderCards do not have a set height, instead they depend on .name and .stats lines in the footer */}
                &nbsp;
              </div>
            </div>
          </div>
        }
      />
      {isMediaManagerShown && (
        <MediaManager
          initialMediaSource={
            gallectionType === GallectionType.GALLERY
              ? MediaSourceType.GALLERY
              : MediaSourceType.COLLECTION
          }
          withMediaSourceSelector={false}
          withNewGallectionPopupOpen
          onDone={closeMediaManagerAndReload}
          onClose={closeMediaManagerAndReload}
        />
      )}
    </>
  );
};

AddNewFolderCard.displayName = 'AddNewFolderCard';
export default AddNewFolderCard;
